module.exports = __webpack_public_path__ + "img/webinar2.acaa1e81.jpg";